var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"thank-you"}},[_c('dash-header',{attrs:{"pages":_vm.breadCrumbsPages,"dashboardTitle":'Thank you'}}),_c('a-card',[_c('h3',[_vm._v("Thank you for your TELAS registration.\n      Please check your inbox to\n      confirm your registration and then\n      login to complete a user profile\n    ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }